define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Templates {
        static EncodeId(s) {
            if (s === "")
                return "_";
            var re = new RegExp("[^a-zA-Z0-9-]", "g");
            return s.replace(re, function (m) {
                return "_" + m[0].charCodeAt(0).toString(16) + "_";
            });
        }
        static LoadCSS(url) {
            var dfd = $.Deferred();
            var id = Templates.EncodeId(url);
            if (document.getElementById(id) == null) {
                var loadingTemplate = $.grep(Templates.loadingCssPromises, p => p.id == id)[0];
                if (loadingTemplate != null) {
                    loadingTemplate.promise.always(() => dfd.resolve());
                    return dfd.promise();
                }
                var v = window["globalScriptVersion"];
                if (!v || v.toLowerCase() == "test")
                    v = $.now();
                Templates.loadingCssPromises.push({
                    id: id,
                    promise: $.get(url, { "v": v }, function (result) {
                        var existingTemplate = $("#" + id)[0];
                        if (existingTemplate == null) {
                            var style = document.createElement("style");
                            style.type = "text/css";
                            style.innerHTML = result;
                            style.id = id;
                            document.getElementsByTagName("head")[0].appendChild(style);
                        }
                    }).always(function () {
                        dfd.resolve();
                    })
                });
            }
            else {
                dfd.resolve();
            }
            return dfd.promise();
        }
        static getTemplateHtml(id) {
            var html = document.getElementById(id);
            if (html)
                return $(html).html();
            return null;
        }
        static LoadTemplate(url, htmlTag) {
            var dfd = $.Deferred();
            var id = Templates.EncodeId(url);
            var html = Templates.getTemplateHtml(id);
            if (html == null) {
                var loadingTemplate = $.grep(Templates.loadingTemplatePromises, p => p.id == id)[0];
                if (loadingTemplate != null) {
                    loadingTemplate.promise.always(() => dfd.resolve());
                    return dfd.promise();
                }
                var v = window["globalScriptVersion"];
                if (!v || v.toLowerCase() == "test")
                    v = $.now();
                Templates.loadingTemplatePromises.push({
                    id: id,
                    promise: $.get(url, { "v": v }, function (result) {
                        var existingTemplate = $("#" + id)[0];
                        if (existingTemplate == null) {
                            var sc = !htmlTag
                                ? `<script type="text/html" id="${id}">${result}</script>`
                                : `<${htmlTag} id="${id}">${result}</${htmlTag}>`;
                            $("body").append(sc);
                        }
                    }).always(function () {
                        dfd.resolve(Templates.getTemplateHtml(id));
                    })
                });
            }
            else {
                dfd.resolve(html);
            }
            return dfd.promise();
        }
    }
    exports.default = Templates;
    Templates.loadingCssPromises = [];
    Templates.loadingTemplatePromises = [];
});
//# sourceMappingURL=Templates.js.map